import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=61f9ecd6&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61f9ecd6')) {
      api.createRecord('61f9ecd6', component.options)
    } else {
      api.reload('61f9ecd6', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=61f9ecd6&", function () {
      api.rerender('61f9ecd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/NotFound.vue"
export default component.exports